/**
 * @generated SignedSource<<291642a9b95d47dee12675ae09fadcc4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConditionalFormattingSidebarExperience_view$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FormatRulesNew_view" | "RuleList_view">;
  readonly " $fragmentType": "ConditionalFormattingSidebarExperience_view";
};
export type ConditionalFormattingSidebarExperience_view$key = {
  readonly " $data"?: ConditionalFormattingSidebarExperience_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarExperience_view">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConditionalFormattingSidebarExperience_view",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "FormatRulesNew_view"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RuleList_view"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};
})();

(node as any).hash = "6e9fbc4124078cfcd1116070971e0363";

export default node;
